import { render } from "./ContactUsSecondary.vue?vue&type=template&id=8ad97470&scoped=true&ts=true"
import script from "./ContactUsSecondary.vue?vue&type=script&lang=ts"
export * from "./ContactUsSecondary.vue?vue&type=script&lang=ts"

import "./ContactUsSecondary.vue?vue&type=style&index=0&id=8ad97470&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad97470"]])

export default __exports__